import alpine from "./modules/alpine";
import swiper from "./modules/swiper";
import aos from "./modules/aos";

window.addEventListener("DOMContentLoaded", () => {
  alpine();
  swiper();
  aos();
});
